export const environment = {
  production: false,
  name: 'staging',

  backend: {
    url: 'https://api.backofficeqa.fsbr.qualitylabs.com.br',
  },
  recaptcha: {
    siteKey: null,
  }
};
